import React, { useContext, useState } from 'react';
import { AutomationSection } from "../../context/AutomationContext";
import { ScenariosList } from "../Scenarios";

const AutomationElsePage = () => {
    const { AutomationShowHideFunc } = useContext(AutomationSection);
    const [showScenarios, setShowScenarios] = useState(false)

    return (
        <div className="px-3">
            {!showScenarios ?
                <>
                    <h5 className="text-right mb-4">آنگاه</h5>
                    <div className="addScenarioCard mb-3 bg-white d-flex justify-content-between align-items-center p-3">
                        <div className="text-right">
                            <p className="mb-1 fn">دستگاه ها</p>
                        </div>
                        <div className="addScenarioIcon d-flex justify-content-center align-items-center rounded-circle text-white cursor"
                        >+</div>
                    </div>
                    <div className="addScenarioCard mb-3 bg-white d-flex justify-content-between align-items-center p-3">
                        <div className="text-right">
                            <p className="mb-1 fn">اطلاع رسانی</p>
                        </div>
                        <div className="addScenarioIcon d-flex justify-content-center align-items-center rounded-circle text-white cursor"
                        >+</div>
                    </div>
                    <div className="addScenarioCard mb-3 bg-white d-flex justify-content-between align-items-center p-3">
                        <div className="text-right">
                            <p className="mb-1 fn">اجرای سناریو</p>
                        </div>
                        <div className="addScenarioIcon d-flex justify-content-center align-items-center rounded-circle text-white cursor"
                        >+</div>
                    </div>
                    <div className="addScenarioCard mb-3 bg-white d-flex justify-content-between align-items-center p-3">
                        <div className="text-right">
                            <p className="mb-1 fn">اجرای چند سناریو</p>
                        </div>
                        <div className="addScenarioIcon d-flex justify-content-center align-items-center rounded-circle text-white cursor"
                        >+</div>
                    </div>
                    <div className="addScenarioCard mb-3 bg-white d-flex justify-content-between align-items-center p-3">
                        <div className="text-right">
                            <p className="mb-1 fn">راهنمای صوتی</p>
                        </div>
                        <div className="addScenarioIcon d-flex justify-content-center align-items-center rounded-circle text-white cursor"
                        >+</div>
                    </div>
                    <div className="d-flex flex-wrap justify-content-center mt-5">
                        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                            onClick={() => setShowScenarios(true)}
                        >
                            <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
                            <small className="fn12 mt-1">ذخیره</small>
                        </div>
                        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                            onClick={() => AutomationShowHideFunc('ifPage')}
                        >
                            <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
                            <small className="fn12 mt-1">بازگشت</small>
                        </div>
                    </div>
                </>
                :
                <>
                    <ScenariosList />
                    <div className="d-flex flex-wrap justify-content-center mt-5">
                        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                            onClick={() => AutomationShowHideFunc('firstPage')}
                        >
                            <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
                            <small className="fn12 mt-1">ذخیره</small>
                        </div>
                        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                            onClick={() => setShowScenarios(false)}
                        >
                            <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
                            <small className="fn12 mt-1">بازگشت</small>
                        </div>
                    </div>
                </>
            }
        </div>
    );
};

export { AutomationElsePage };